/*
 * Назначение: точка входа React-приложения админ-панели «ИИ-продавец».
 * Функционал: монтирует <App /> в #root, подключает глобальные стили и Tailwind.
 */

import { createRoot } from "react-dom/client";
import App from "./app/App";
import "./styles/index.css";

createRoot(document.getElementById("root")!).render(<App />);
